export default "__VITE_ASSET__BPBABhtk__"